export const technologies = {
  React: "React",
  PostgreSQL: "PostgreSQL",
  TypeOrm: "TypeOrm",
  Typescript: "Typescript",
  Nestjs: "Nestjs",
  SCSS: "SCSS",
  HTML: "HTML",
  CSS: "CSS",
  JavaScript: "JavaScript",
  API: "API",
  LocalStorage: "LocalStorage",
  Node: "NodeJs",
  Mongo: "MongoDB",
  Express: "Express",
  Stripe: "Stripe",
  Tailwind: "Tailwind",
  Git: "GIT",
  NextJs: "NextJs",
  FramerMotion: "Framer Motion",
  Redux: "Redux",
  Docker:"Docker",
  GoogleAuth:"GoogleOAuth",
};
